<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="商品编码" prop="goodsCode">
            <el-input v-model.trim="searchForm.goodsCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input v-model.trim="searchForm.goodsName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="更新时间" prop="date">
            <el-date-picker
              v-model="searchForm.date"
              unlink-panels
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button class="orange-btn" size="mini" @click="read">已读</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.records"
        :height="maxTableHeight"
        :cell-style="cellStyle"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            <template v-if="item.displayName === '图片'">
              <el-button v-if="scope.row.imgUrlList && scope.row.imgUrlList.length" size="mini" type="text" @click="viewImg(scope.row.imgUrlList)"
                >查看</el-button
              >
            </template>
            <template v-else>
              {{ scope.row[item.columnName] | cellValFormat }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="140">
          <template slot-scope="{ row }">
            <el-button type="text" @click="record(row)">查看调整记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 调整记录 -->
    <record-details :visible.sync="isShowDetails" v-if="isShowDetails" :rowData="rowData" :columnData="columnData" @success="onSearch" />
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import imgShow from '@/views/components/imgShow';
import axios from '@/utils/axiosInstance';
import recordDetails from './components/recordDetails.vue';
import { downloadFile } from '@/utils';
import moment from 'moment';
export default {
  name: 'CommodityPriceChange',
  mixins: [tableMixin, pagePathMixin],
  components: {
    recordDetails,
    imgShow,
  },
  data() {
    return {
      loading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: 'skuSalesPriceChangeList',
      columnData: [],
      loading: false,
      searchForm: {
        goodsCode: '',
        goodsName: '',
        date: [],
      },
      exportData: {},
      rowData: {},
      searchCollapse: false,
      isShowEdit: false,
      isShowDetails: false,
      imgFormVisible: false,
      queryCriteria: [],
      spuCategoryList: [],
      goodsLocationList: [],
      productTypeList: [],
      imgList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  computed: {},
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
        this.init();
      });
    },
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let { date } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          startDate: date && date[0] ? date[0] : '',
          endDate: date && date[1] ? date[1] : '',
        },
      };
      this.searchFormData = data;
      this.$q.goods
        .changeListSearch({ data: data })
        .then((res) => {
          if (res.success) {
            this.tableData = res.data;
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    record(row) {
      this.rowData = { ...row };
      this.isShowDetails = true;
    },
    viewImg(imgList) {
      this.imgList = imgList.map((v) => v.path);
      this.imgFormVisible = true;
    },
    read() {
      this.$q.goods.changeListRead({ data: this.searchFormData }).then((res) => {
        if (res.success) {
          this.$message.success('已读成功');
          this.onSearch();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 导出
    exportExcel() {
      let _this = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$q.goods.changeListExport({ data: this.searchFormData }).then((res) => {
        console.log(res);
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.data] })
            .then((res) => {
              if (res.data.taskStatus == "执行完成") {
                clearInterval(timer);
                loading.close();
                _this.downloadRes(res.data.filePath, res.data.fileName);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.message);
            });
        }, 5000);
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let redProp = JSON.parse(row.adjustmentProperties)
      if (redProp.includes(column.property)) {
        return 'color: red';
      }
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    this.columns();
  },
};
</script>

<style lang="stylus" scoped></style>
